export const LOADER_STATUS = "boilerplate/Notes/Module/LOADER_STATUS";
export const SET_SELECTED_NOTES = "boilerplate/Notes/Module/SET_SELECTED_NOTES";
export const SET_SELECTED_ROW_NOTES = "boilerplate/Notes/Module/SET_SELECTED_ROW_NOTES";
export const SET_TABLE_DATA = "boilerplate/Notes/Module/SET_TABLE_DATA";
export const SET_ENTITY_MASTER_LIST = "boilerplate/Notes/Module/SET_ENTITY_MASTER_LIST";
export const SET_DEFAULT_ENTITY = "boilerplate/Notes/Module/SET_DEFAULT_ENTITY";
export const SET_PROFILE_DATA = "boilerplate/Notes/Module/SET_PROFILE_DATA";
export const SET_SELECTED_GSTIN = "boilerplate/Notes/Module/SET_SELECTED_GSTIN";
export const SET_SELECTED_PERIODS = "boilerplate/Notes/Module/SET_SELECTED_PERIODS";
export const SET_OPEN_ADD_NOTES = "boilerplate/Notes/Module/SET_OPEN_ADD_NOTES";
export const SET_MODULE_IDS = "boilerplate/Notes/Module/SET_MODULE_IDS";
export const SET_TOTAL_PAGES = "boilerplate/Notes/Module/SET_TOTAL_PAGES";
export const SET_SELECTED_MODULE = "boilerplate/Notes/Module/SET_SELECTED_MODULE";
export const SET_SELECTED_CATEGORY = "boilerplate/Notes/Module/SET_SELECTED_CATEGORY";
export const SET_SEARCH = "boilerplate/Notes/Module/SET_SEARCH";
export const SET_COMMENT_TABLE_DATA = "boilerplate/Notes/Module/SET_COMMENT_TABLE_DATA";
export const SET_FILES_DATA = "boilerplate/Notes/Module/SET_FILES_DATA";
export const SET_NOTES_HEADING_DATA = "boilerplate/Notes/Module/SET_NOTES_HEADING_DATA";